export const SET_TOAST_NOTIFICATION_DATA = 'SET_TOAST_NOTIFICATION_DATA'

export const setNotificationData = (data: any) => (dispatch: any) => {
	return dispatch({
		type: SET_TOAST_NOTIFICATION_DATA,
		data,
	})
}
